
import React, { useState, useEffect, useContext } from 'react';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import Boton from '../eventos/navegacion_y_accion/Boton';
import Titulo from "../basicos/Titulo";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { fetchCrearEmpresa } from '../../../peticiones_API/PeticionesGestionPersonasEmpresas';
import ErrorForm from '../eventos/avisos/Alerta';
import { handleChangeErrors, handleSubmitErrorsEmpresas, todosDatosCorrectos } from '../../validacion/ValidationFormEmpresa';
import { DatosCorrectosEmpresa, ServerNoCreoEmpresa, DatosIncorrectos } from '../eventos/avisos/VentanaEmergente';
import { ChromePicker } from 'react-color';
import { ToastContainer, toast } from "react-toastify";
import useFormPersistence from '../../../hooks/useFormPersistence';
import { getProvincias, getMunicipios, buscarDireccionPorCP, buscarCPPorPoblacion, buscarProvinciaPorNombre } from '../../../utils/direccionesUtils';
import { Building2, MapPin } from 'lucide-react';

const FormCrearEmpresa = () => {

    const initialFormState = {
            razon_social: "",
            cif: "",
            direccion: "",
            codigo_postal: null,
            provincia: "",
            poblacion: ""
        };
    
    const [formData, setFormData, clearFormDraft, wasRestored] = useFormPersistence(
        'crear_negocio',
        initialFormState
    );

    const camposRequeridos = {
        razon_social: "Debes Ingresa la razón social",
        cif: "Debes ingresar el CIF de tu empresa",
    };
    
    const [estadoCampoReque, setEstadoCampoReque] = useState({
        razon_social: null,
        cif: null,
    });

    const [formCompletado, setFormCompletado] = useState(null);
    const [estadosActualizados, setEstadosActualizados] = useState(false);
    const [provinciaId, setProvinciaId] = useState(null);
    const [municipios, setMunicipios] = useState([]);
    const [errorEnviarForm, setErrorEnviarForm] = useState({
        negocioDuplicado: null,
    });

    const provincias = getProvincias();

    const handleSubmit = async (event) => {
        event.preventDefault();

        setEstadosActualizados(false);

        handleSubmitErrorsEmpresas(formData, estadoCampoReque, setEstadoCampoReque, camposRequeridos, setEstadosActualizados);
    };


    const handleChange = (event) => {
        setFormCompletado(null); // Cuando se hacen cambios los datos no están listos.      

        const { name: inputName, value: inputValue, type, files } = event.target;
        const fieldName = inputName;
        let newValue;

        if (type === 'file') {
            newValue = files[0];
        } 
        else {
            newValue = inputValue;
        }

        // Update logic for address fields
        if (fieldName === 'codigo_postal' && inputValue.length === 5) {
            const address = buscarDireccionPorCP(inputValue);
            if (address) {
                setFormData(prev => ({
                    ...prev,
                    ...address,
                    codigo_postal: inputValue
                }));
                setProvinciaId(address.provinciaId);
            } else {
                setFormData(prev => ({ ...prev, [fieldName]: newValue }));
            }
        } else if (fieldName === 'provincia') {
            const provId = buscarProvinciaPorNombre(inputValue);
            setProvinciaId(provId);
            setFormData(prev => ({ ...prev, provincia: inputValue, poblacion: '', codigo_postal: '' }));
        } else if (fieldName === 'poblacion' && inputValue && formData.provincia) {
            const cp = buscarCPPorPoblacion(formData.provincia, inputValue);
            if (cp) {
                setFormData(prev => ({ ...prev, poblacion: inputValue, codigo_postal: cp }));
            } else {
                setFormData(prev => ({ ...prev, [fieldName]: newValue }));
            }
        } else {
            setFormData(prevFormData => ({ ...prevFormData, [fieldName]: newValue }));
        }
        

        if (fieldName in estadoCampoReque) {
            handleChangeErrors(fieldName, inputValue, estadoCampoReque, setEstadoCampoReque, setEstadosActualizados);
        }

    }

    useEffect (() => { 

        if (estadosActualizados) {
            let validacionTodosDatos = todosDatosCorrectos(formData, estadoCampoReque);
            let todosCamposFalse = validacionTodosDatos.todosCamposFalse();
            (async () => {
                if (todosCamposFalse === true) {
                    setErrorEnviarForm(prevFormData => ({ ...prevFormData, negocioDuplicado: false }));
                    setFormCompletado(true);
                    try {
                        const response = await fetchCrearEmpresa(formData);

                        console.log("Empresa creada: ", response);

                    } catch (error) {
                        console.error(error?.response?.data?.error);

                        if (error?.response?.data?.error === 'REGISTRO_DUPLICADO') {
                            setErrorEnviarForm(prevFormData => ({ ...prevFormData, empresaDuplicada: true }));
                        }
                        setFormCompletado(false);

                    }
                } else {
                    toast.error("Faltan campos por rellenar")
                }
            })();
        }
    }, [estadosActualizados, formData, estadoCampoReque])

    useEffect(() => {
        const nuevosMunicipios = getMunicipios(provinciaId);
        setMunicipios(nuevosMunicipios);
    }, [provinciaId]);


    return ( 
        <>
            <Form>
                <CabeceraForm>
                    <Titulo texto="AGREGA UNA EMPRESA" />
                </CabeceraForm>

                <Container>
                    <ToastContainer/>
                    <Col>
                        <SeccionCard>
                            <TituloSeccion>
                                <Building2 size={20} /> Datos Principales 
                            </TituloSeccion>
                            <CampoGrid $columnas={2}>
                                <Form.Group>
                                    <TituloCategoria>Razón Social</TituloCategoria>
                                    <Form.Control type='text' name='razon_social' value={formData.razon_social || ''} onChange={handleChange} />
                                    <ErrorForm mensaje={camposRequeridos.razon_social} estadoAlerta={estadoCampoReque.razon_social} />
                                </Form.Group>

                                <Form.Group>
                                    <TituloCategoria>CIF</TituloCategoria>
                                    <Form.Control type='text' name='cif' value={formData.cif || ''} onChange={handleChange} />
                                    <ErrorForm mensaje={camposRequeridos.cif} estadoAlerta={estadoCampoReque.cif} />
                                </Form.Group>
                            </CampoGrid>
                        </SeccionCard>


                        <SeccionCard>
                            <TituloSeccion>
                                <MapPin size={20} /> Ubicación
                            </TituloSeccion>
                            <CampoGrid $columnas={3}>
                                <Form.Group>
                                    <TituloCategoria>Código Postal</TituloCategoria>
                                    <Form.Control type="number" name="codigo_postal" value={formData.codigo_postal || ''} onChange={handleChange} />
                                </Form.Group>

                                <Form.Group>
                                    <TituloCategoria>Provincia</TituloCategoria>
                                    <Form.Select value={formData.provincia || ''} name="provincia" onChange={handleChange}>
                                        <option value="">Seleccionar...</option>
                                        {provincias.sort((a, b) => a.localeCompare(b)).map((provincia, index) => (
                                            <option key={index} value={provincia}>{provincia}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>

                                <Form.Group>
                                    <TituloCategoria>Población</TituloCategoria>
                                    <Form.Select value={formData.poblacion || ''} name="poblacion" onChange={handleChange}>
                                        <option value="">Seleccionar...</option>
                                        {municipios.map((poblaciones, index) => (
                                            <option key={index} value={poblaciones.name}>{poblaciones.name}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>

                            </CampoGrid>

                            <CampoGrid $columnas={1} >
                                <Form.Group>
                                    <TituloCategoria>Dirección</TituloCategoria>
                                    <Form.Control type='text' name='direccion' value={formData.direccion || ''} onChange={handleChange} />
                                </Form.Group>
                            </CampoGrid>
                        </SeccionCard>

                        <Row>
                            <ContenedorBotones style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}>
                                <Boton
                                    bonificados="true"
                                    grande="true"
                                    as="button"
                                    primario="true"
                                    type="submit"
                                    onClick={handleSubmit}
                                    form="true"
                                >
                                    Crear Empresa
                                </Boton>
                                <Boton
                                    grande="true"
                                    to="/gestionpersonas/empresas"
                                >
                                    Cancelar
                                </Boton>
                            </ContenedorBotones>
                        </Row>
                    </Col>
                </Container>
            </Form>
            <DatosCorrectosEmpresa envioActivado={formCompletado} />
            <DatosIncorrectos envioActivado={formCompletado} duplicado={errorEnviarForm.empresaDuplicada} />
            <ServerNoCreoEmpresa envioActivado={errorEnviarForm.empresaDuplicada} />
        </>
     );
}
 
export default FormCrearEmpresa;

const ContenedorBotones = styled.div`
    display: flex;
    gap: 15px;
    justify-content: center;
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid #e0e0e0;
`

const CabeceraForm = styled.div`
    margin: 2% 0% 0% 35%;
`

const ContenedorEncabezado = styled.div`
    width: 100%;
    height: 240px;
    border: 3px solid rgba(0, 60, 102, 0.8);
    border-radius: 12px;
    overflow: hidden;
    position: relative;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8f9fa;
`

const SeccionCard = styled.div`
    background: ${props => props.$destacado ? 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' : '#ffffff'};
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    padding: 24px;
    margin-bottom: 24px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
    transition: box-shadow 0.2s ease;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }
`

const CampoGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(${props => props.$columnas || 4}, 1fr);
    gap: 20px;
    margin-bottom: 20px;

    @media (max-width: 992px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 576px) {
        grid-template-columns: 1fr;
    }
`

const TituloCategoria = styled(Form.Label)`
    font-weight: 600;
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    line-height: 1.6;
    color: #495057;
    margin-bottom: 6px;
    display: block;

    span {
        color: #dc3545;
        font-weight: 400;
        margin-left: 2px;
    }
`

const TituloSeccion = styled.h4`
    font-weight: 700;
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    margin: 0 0 20px 0;
    color: rgba(0, 60, 102, 0.9);
    border-bottom: 2px solid rgba(0, 60, 102, 0.3);
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 10px;

    svg {
        opacity: 0.8;
    }
`